module.exports = __webpack_public_path__ + "static/media/bombolulu_bedsitters4.e961315b.webp";